import React from 'react';

const InitialDataContext = React.createContext({});
const { Provider: InitialDataProvider } = InitialDataContext;

export { InitialDataProvider, InitialDataContext };
